const de = {
  common: {
    loading: "Wird geladen...",
    search: "Suchen",
    next: "Weiter",
    back: "Zurück",
    cancel: "Abbrechen",
    until: "Bis",
    data: "Daten",
    edit: "Bearbeiten",
    chat: "Chat",
    language: "Sprache",
    interests: "Interessen",
  },
  Home: {
    welcome: "Willkommen zuhause!",
  },
  forms: {
    name: "Name",
    firstName: "Vorname",
    lastName: "Nachname",
    username: "Benutzername",
    email: "E-mail",
    confirmEmail: "E-mail bestätigen",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    login: "Einloggen",
    loginTitle: "Logge dich ein",
    register: "Registrieren",
    registerTitle: "Registriere dich",
    registerDescription:
      "Gebe deinen Namen, deine E-Mail und dein Passwort ein",
    chooseLanguages: "Wähle die Sprachen aus welche du sprichst",
    chooseInterests: "Wähle deine Interessen aus",
    chooseSkills: "Füge deine Fähigkeiten hinzu",
    addSkill: "Fähigkeit",
    signout: "Abmelden",
    save: "Speichern",
    done: "Fertig",
    cancel: "Abbrechen",
    or: "Oder",
    completeRegistration: "Registrierung abschließen",
  },
  nav: {
    profile: "Mein Konto",
    projects: "Projekte",
    feed: "Feed",
    explore: "Projekt finden",
    myAccount: "Mein Konto",
    jobs: "Jobs",
  },
  profile: {
    profile: "Profil",
    name: "Name",
    username: "Nutzername",
    credentials: "Anmeldedaten",
    email: "Email",
    location: "Standort",
    bio: "Biografie",
    skills: "Fähigkeiten",
    languages: "Sprachen",
    interests: "Interessen",
    following: "Abonniert",
    followers: "Abonnenten",
    editProfile: "Profil bearbeiten",
  },
  steps: {
    next: "Weiter",
    back: "Zurück",
    data: "Daten",
    name: "Name",
    description: "Beschreibung",
    language: "Sprache",
    interests: "Interessen",
    skills: "Fähigkeiten",
    photo: "Bild",
    category: "Kategorie",
    timePeriod: "Zeitraum",
    members: "Mitglieder",
  },
  project: {
    requestedProjects: "Angefragte Projekte",
    joinedProjects: "Beigetretenen Projekte",
    createdProjects: "Erstellte Projekte",
    members: "Mitglieder",
    owner: "Besitzer",
    roles: "Rollen",
    applications: "Bewerbungen",
    requirements: "Qualifikationen",
    createProject: "Projekt erstellen",
    projectInformation: "Projekt Information",
    name: "Name",
    description: "Beschreibung",
    roleName: "Rollenname",
    projectName: "Projektname",
    skill: "Fähigkeit",
    skills: "Fähigkeiten",

    addName: "Wähle einen Namen für dein Projekt",
    addPhoto: "Füge deinem Projekt ein Bild hinzu (optional)",
    addDescription: "Füge eine Beschreibung hinzu",
    addLanguages: "Füge eine Sprache hinzu (max 2)",
    addCategories: "Füge deinem Projekt Kategorien hinzu (max 3)",
    addTimePeriod: "Wähle den Zeitraum aus (optional)",
    addRoles: "Füge Rollen hinzu (optional)",
    title: "Bezeichnung",
    addTitle: "Gebe eine Rollenbezeichnung ein",
    createRole: "Rolle erstellen",
    addSkill: "Gebe eine Fähigkeit ein",
    addRole: "Diese Rolle hinzufügen",

    openVacancies: "Offene Stellen",
    roleDescription: "Stellenbeschreibung",
    roleRequirements: "Fähigkeiten für Stelle",
    apply: "Bewerben",

    exitProject: "Aus Projekt austreten",
    deleteProject: "Projekt löschen",
    deleteProjectWarning:
      "Bist du dir sicher dass du dieses Projekt löschen möchtest. Dieser Schritt kann nicht wieder rückgängig gemacht werden.",

    status: {
      root: "Status",
      inProgress: "Im Gange",
      idle: "Inaktiv",
      done: "Erledigt",
    },
  },
  interests: {
    cryptocurrency: "Kryptowährung",
    business: "Wirtschaft",
    psychology: "Psychologie",
    philosophy: "Philosophie",
    work: "Arbeit",
    money: "Geld",
    future: "Zukunft",
    technology: "Technologie",
    travel: "Reisen",
    programming: "Programmierung",
    electro: "Elektro",
    startup: "Startup",
    cybersecurity: "Cybersecurity",
    writing: "Schreiben",
    life: "Leben",
    literature: "Literatur",
    art: "Kunst",
    design: "Design",
    photography: "Fotografie",
    culture: "Kultur",
    music: "Musik",
    dancing: "Tanzen",
  },
  application: {
    viewApplication: "Bewerbung anzeigen",
  },
  chat: {
    writeMessage: "Schreibe eine Nachricht...",
  },
  launchScreen: {
    sectionOne: {
      heading: "Lass uns zusammenarbeiten!",
      text: "Mit WeCollab hast du die Möglichkeit ein Projekt zu erstellen und diesem bestehende Teammitlgieder hinzuzufügen als auch neue Teammitglieder suchst.",
    },
    sectionTwo: {
      heading: "Erstelle Projekte",
      text: "Du hast die Möglichkeit Projekte zu erstellen und bestehende Mitglieder hinzuzufügen oder erstelle ein neues Projekt und finde neue Teammitglieder.",
    },
    sectionThree: {
      heading: "Finde Projekte",
      text: "Du bist auf der Suche nach einer neuen Herausforderung? Dann ist WeCollab die richtige Wahl! Du hast die Möglichkeit nach Projekten mit deinen Interessen und deinen Fähigkeiten beizutreten.",
    },
    sectionFour: {
      heading: "Knüpfe neue Kontakte",
      text: "Durch WeCollab hast du die Möglichkeit neue Kontakte zu finden, welche dir auch in der Zukunft weiterhelfen. Du kannst dir ein Netzwerk aufbauen auf welches du jederzeit zugreifen kannst.",
    },
  },
};

export default de;
